import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BrandHeader from "@/components/BrandHeader";
import SpinnerButton from "@/components/SpinnerButton";
import { adminApi } from "@/lib/api";
import { usePageMeta } from "@/lib/usePageMeta";

export default function AdminLogin() {
  usePageMeta({ title: "Admin Sign In \u2014 SCW Contact Hub", robots: "noindex, nofollow" });
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await adminApi.login(email, password);
      nav("/admin/dashboard");
    } catch (e2) {
      setError(e2?.response?.data?.detail || "Login failed.");
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#FFFFFF", display: "flex", flexDirection: "column" }}>
      <BrandHeader label={"Contact Hub \u00b7 Admin"} homeHref="/admin/login" testIdPrefix="admin-login-header" />
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 28px" }}>
        <form onSubmit={submit} style={{ width: "100%", maxWidth: 380 }} data-testid="admin-login-form">
          <p className="scw-eyebrow" style={{ marginBottom: 8 }}>Sign in</p>
          <h1 style={{ fontSize: 28, margin: "0 0 32px 0" }}>Admin access</h1>
          <div style={{ marginBottom: 22 }}>
            <label className="scw-label">Email</label>
            <input className="scw-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
          </div>
          <div style={{ marginBottom: 22 }}>
            <label className="scw-label">Password</label>
            <input className="scw-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
          </div>
          {error && <p style={{ color: "#a13b3b", fontSize: 13, marginBottom: 12 }} data-testid="admin-login-error">{error}</p>}
          <SpinnerButton loading={loading} dataTestId="admin-login-submit">Sign in</SpinnerButton>
        </form>
      </div>
    </div>
  );
}
